export default __webpack_public_path__ + "static/media/BCA14.e23f5ac1.jpg";